
import {auth} from "@/scripts/firebase"
import {updateProfile} from "firebase/auth"
//import {ref,uploadBytes,getDownloadURL} from "firebase/storage"
import {UserAccount, NoticeProps } from "@/scripts/datatypes"
import {} from "../common-datatypes"
import { Component, Mixins} from "vue-property-decorator"
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
import { ValidationFlags } from "vee-validate/dist/types/types"
//import { ValidationFlags } from "vee-validate/dist/types/types"
//import {toHiragana,toZenKana} from 'jaconv'

/**
 * アップロード画像の内容チェック ファイル形式 サイズ
 * エラー表示
 */

@Component({
  components: {
  }
})

export default class Account extends Mixins(Common) {
  isLoading = false
  notice: NoticeProps = {}
  userAccount: UserAccount = {}
  disabledUpdateAccount = true

  mounted(){
    console.log('mounted')

    this.$watch('observerAccount.flags',(flags: ValidationFlags) =>{
      this.disabledUpdateAccount = ! flags.changed
    })
  }

  get observerAccount() {
    return this.$refs.accountValidationObserver as InstanceType<typeof ValidationObserver>
  }

  async created() {
    console.trace('created')

    this.userAccount = {...this.$store.state.user}

    try{
      /*
      this.$store.commit('setLoading',true)
      this.isLoadingImage = true

      const profileImageFileName = `${this.$store.state.userPublicProfile.profileImage}${this.$data.$profileThumbnailSize}`

      const userImagesRef = this.$getUserImagesRef()
    
      const profileRef = ref(userImagesRef,`profile/${profileImageFileName}`)

      this.profileImageSrc = await getDownloadURL(profileRef)
      */
    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
    }
  }

  async updateAccount(){
    try{
      this.notice = {
				isShow: false,
      }
			
			if(await this.observerAccount.validate()){
        const updateUserAccount = {...this.userAccount}
        let field: string
      
        for(field in this.userAccount){
          if(this.observerAccount.fields[field] && (this.observerAccount.fields[field].dirty === true || this.observerAccount.fields[field].changed === true)){
            continue
          }
          delete(updateUserAccount[field as keyof UserAccount])
        }
        
        if(Object.keys(updateUserAccount).length > 0){
          this.$store.commit("setLoading",true);
          this.isLoading = true

          const user = auth.currentUser

          if(user && updateUserAccount.displayName){
            await updateProfile(user,{
              displayName: updateUserAccount.displayName
            })
            this.$store.commit("setUser",user);
          }

          this.notice = {
            message: this.$t('profile.updated') as string,
            isShow: true,
            type: {'is-success': true}
          }
          this.observerAccount.reset()
        }else{
          this.notice = {
            message: this.$t('profile.noChangedFields') as string,
            isShow: true,
            type: {'is-info': true}
          }
        }
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      this.observerAccount.reset()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
